import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';
import { typographyLineHeightCfg } from 'ds/components/typography/types';

export const Wrapper = styled.div<{ noShadow: boolean }>`
  margin: 0 auto;
  max-width: 644px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  display: flex;
  box-shadow: ${({ theme, noShadow }) => noShadow ? 'none' : theme.shadow.level2};
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-left: ${theme.spacing(2)};
    margin-right: ${theme.spacing(2)};
  `}
`;

export const SectionLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 164px;
  ${({ theme }) => `
    padding: ${theme.spacing(2.5)} ${theme.spacing(3)} ${theme.spacing(3)};
    border-left: 1px solid ${theme.colors.neutrals.grey8};
  `}
`;

export const Logo = styled.div`
  width: 80px;
  height: 80px;
  line-height: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: ${({ theme }) => theme.borderRadius.tiny};
  }
  padding: 5px;
  ${({ theme }) => `
    border: 1px solid ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.small};
    margin-bottom: ${theme.spacing(0.25)};
  `}
`;

export const AgentLogo = styled(Logo)`
  width: 104px;
  height: 104px;
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.round};
    overflow: hidden;
    img {
      border-radius: ${theme.borderRadius.round};
      overflow: hidden;
    }
  `}
`;

export const NoOfficeWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
`;

export const Title = styled(SmallText)`
  white-space: pre-wrap;
  line-height: ${typographyLineHeightCfg.text}px;
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey2};
    margin-bottom: ${theme.spacing(1)};
  `}
`;

export const AgentTitle = styled(Title)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey3};
    margin-bottom: 0;
    margin-top: -${theme.spacing(1)};
  `}
`;

export const Phone = styled(SmallText.withComponent('a'))`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-decoration: none;
  white-space: nowrap;
  svg {
    path {
      fill: ${({ theme }) => theme.colors.neutrals.grey1};
    }
  }
`;

export const MobilePhone = styled(Text.withComponent('a'))`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-decoration: none;
`;

export const FormWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(3)}`};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-left: ${theme.spacing(5)};
    padding-right: ${theme.spacing(5)};
  `}
`;

export const OrByPhone = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const OrByPhoneText = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;
